import { STORE_LOCATOR_URLS } from '../settings/yext';

export function getStoreLocatorUrl(locale) {
  if (STORE_LOCATOR_URLS[locale]) {
    return  STORE_LOCATOR_URLS[locale];
  }
  return `//www.dior.com/fashion/stores/${locale}/search`;
}


// WEBPACK FOOTER //
// ./src/services/yext.js